export default __webpack_public_path__ + "static/media/re.64166e4a.jpeg";